import { useCallback, useEffect, useState } from 'react';

import {
  BondInsuranceInvoiceDTO,
  listBondInsuranceInvoices
} from '../../../services/bond-insurance-invoices';
import { dangerNotification } from '../../../services/notification';

import { BondInsuranceInvoiceFiltersState } from '../types';

type Params = {
  initialFilters: BondInsuranceInvoiceFiltersState;
};

export const useBondInsuranceInvoicesList = ({ initialFilters }: Params) => {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState<BondInsuranceInvoiceDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState<BondInsuranceInvoiceFiltersState>(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState<BondInsuranceInvoiceFiltersState>(initialFilters);

  const loadData = useCallback(async (page = currentPage, pageFilters = appliedFilters) => {
    setIsLoading(true);

    try {
      const response = await listBondInsuranceInvoices({
        page,
        insurerId: pageFilters.insurerId || undefined,
        estateId: pageFilters.estateId || undefined,
        estateUnitId: pageFilters.estateUnitId || undefined,
        accountManager: pageFilters.accountManager || undefined,
        status: pageFilters.status || undefined,
        start: pageFilters.start || undefined,
        end: pageFilters.end || undefined,
        isRv: true
      });

      setItems(response.data || []);
      setTotal(response.quantity || 0);
    } catch (error) {
      dangerNotification('Erro', 'Não foi possível carregar faturas de fiança.');
    } finally {
      setIsLoading(false);
    }
  }, [appliedFilters, currentPage]);

  useEffect(() => {
    loadData(currentPage, appliedFilters);
  }, [currentPage, appliedFilters, loadData]);

  const handleSearch = () => {
    setCurrentPage(1);
    setAppliedFilters(filters);
  };

  const clearFilters = () => {
    setFilters(initialFilters);
    setCurrentPage(1);
    setAppliedFilters(initialFilters);
  };

  return {
    isLoading,
    items,
    total,
    currentPage,
    setCurrentPage,
    filters,
    setFilters,
    appliedFilters,
    setAppliedFilters,
    loadData,
    handleSearch,
    clearFilters
  };
};
